import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Checkbox from 'components/Checkbox';
import Dropdown from 'components/Dropdown';
import Radio from 'components/Radio';
import { Content } from './styles';

const NotificationPreferences = ({
  notificationPreferences,
  setNotificationPreferences
}) => {

  const options = [
    { label: 'Critical only', value: 'CRITICAL' },
    { label: 'High priority and above', value: 'HIGH' },
    { label: 'Medium priority and above', value: 'MEDIUM' },
    { label: 'All alerts', value: 'LOW' },
  ]

  const handleNotificationChannelChange = (channel) => {
    let updatedChannels = notificationPreferences.channels || []
    if (updatedChannels.includes(channel)) {
      updatedChannels = updatedChannels.filter(c => c !== channel)
    } else {
      updatedChannels.push(channel)
    }
    setNotificationPreferences((prev) => ({
      ...prev,
      channels: updatedChannels
    }))
  }

  return (
    <Card>
      <CardHeader>
        <div className="cardTitle">NOTIFICATION PREFERENCES</div>
      </CardHeader>
      <Content>
        <div className='title first'>WHEN SHOULD YOU BE NOTIFIED?</div>
        <div className='optionGroup'>
          <Radio 
            label="Always"
            name="choice"
            value="ALWAYS" 
            checked={notificationPreferences.notifyWhen === 'ALWAYS'}
            onChange={(value) => {
              setNotificationPreferences((prev) => ({
                ...prev,
                notifyWhen: value
              }))
            }} 
          />
          <Radio 
            label="Only when I’m signed in"
            name="choice"
            value="ONLY_WHEN_SIGNED_IN" 
            checked={notificationPreferences.notifyWhen === 'ONLY_WHEN_SIGNED_IN'}
            onChange={(value) => {
              setNotificationPreferences((prev) => ({
                ...prev,
                notifyWhen: value
              }))
            }} 
          />
        </div>
        <div className='title'>NOTIFY ME FOR ALERTS AT THIS PRIORITY OR HIGHER.</div>
        <div className='optionGroup'>
          <Dropdown
            mainPage
            options={options}
            value={options.find(o => o.value === notificationPreferences.minimumAlertLevel)?.label || '-Select-'}
            onChange={(e) => {
              setNotificationPreferences((prev) => ({
                ...prev,
                minimumAlertLevel: e
              }))
            }}
            additionalstyle={`
              width: 300px;
            `}
          />
        </div>
        <div className='title'>HOW SHOULD YOU BE NOTIFIED?</div>
        <div className='optionGroup'>
          <Checkbox
            checked={!!notificationPreferences.channels?.includes('PMS_PUSH')}
            onChange={() => handleNotificationChannelChange('PMS_PUSH')}
            title={"Push notifications"}
          />
          <Checkbox
            checked={!!notificationPreferences.channels?.includes('STAFF_EMAIL')}
            onChange={() => handleNotificationChannelChange('STAFF_EMAIL')}
            title={"Email notifications"}
          />
          <Checkbox
            checked={!!notificationPreferences.channels?.includes('STAFF_SMS')}
            onChange={() => handleNotificationChannelChange('STAFF_SMS')}
            title={"SMS notifications"}
          />
        </div>
      </Content>
    </Card>
  )
}

export default NotificationPreferences;
